import DepsService from 'services/dependencies.js';

const CONTEXT = 'dashboard';

const fetchCurrentLiability = (retailerId: number): Promise<number> => {
  const { url } = DepsService.rest.widgets.instant.myCurrentLiability;
  const urlParams = { retailerId };
  const queryParams = {};

  return DepsService.restSrv.get(CONTEXT, url, queryParams, urlParams);
};

export default {
  fetchCurrentLiability,
};



// WEBPACK FOOTER //
// ./src/modules/dashboard/resources/current-liability.api.ts